import React from 'react';
import zoid from 'zoid';
import ReactDOM from 'react-dom';

const DistributionPickerComponent = zoid.create({
    // The html tag used to render my component
    tag: 'distribution-picker-component',
    // The url that will be loaded in the iframe or popup, when someone includes my component on their page
    url: `/renderer/distribution-picker`,
    dimensions: {
        width: '100%',
        height: '100%'
    },
    containerTemplate: ({document, id, outlet}) => {
        const container = document.createElement('div');
        container.id = id;
        container.className += 'snclient_zoid_component__distribution-picker';
        container.appendChild(outlet);
        return container;
    }
});

export default DistributionPickerComponent.driver('react', {
    React: React,
    ReactDOM: ReactDOM
});



// WEBPACK FOOTER //
// ./approval_queues/components/content_review/list_view/content_row/distribution_picker_component_zoid.js